__turbopack_context__.v({
  "actions": "saltVoteControl-module-scss-module__ZtSB3q__actions",
  "control": "saltVoteControl-module-scss-module__ZtSB3q__control",
  "error": "saltVoteControl-module-scss-module__ZtSB3q__error",
  "heading": "saltVoteControl-module-scss-module__ZtSB3q__heading",
  "hint": "saltVoteControl-module-scss-module__ZtSB3q__hint",
  "login": "saltVoteControl-module-scss-module__ZtSB3q__login",
  "note": "saltVoteControl-module-scss-module__ZtSB3q__note",
  "queueLink": "saltVoteControl-module-scss-module__ZtSB3q__queueLink",
  "retractButton": "saltVoteControl-module-scss-module__ZtSB3q__retractButton",
  "status": "saltVoteControl-module-scss-module__ZtSB3q__status",
  "voteButton": "saltVoteControl-module-scss-module__ZtSB3q__voteButton",
});
